import { render, staticRenderFns } from "./MetricClass.vue?vue&type=template&id=4e3df129&scoped=true"
import script from "./MetricClass.vue?vue&type=script&lang=js"
export * from "./MetricClass.vue?vue&type=script&lang=js"
import style0 from "./MetricClass.vue?vue&type=style&index=0&id=4e3df129&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3df129",
  null
  
)

export default component.exports